module.exports = __webpack_public_path__ + "src/assets/images/logo_hero@2x.png?a35e68b62d4177f0c99be05c0337ceef";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo_hero@2x.png
// module id = 1019
// module chunks = 1